import React from 'react';

export const ErrorPage = () => {
    return (
        <div className='error'>
            Error 404: Page not found
        </div>
    )
};
